import {
  Gear,
  LogoAnsible,
  LogoCloudformation,
  LogoKubernetes,
  LogoOpentofu,
  LogoPulumi,
  LogoTerraform,
  LogoTerragrunt,
} from "components/icons/generated";
import {
  TERRAFORM_CUSTOM_VENDOR,
  VENDOR_CONFIG_TYPENAME,
  VENDOR_DICTIONARY,
} from "constants/vendor";
import Box from "ds/components/Box";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import { Stack, TerraformWorkflowTool as WorkflowTool } from "types/generated";
import { getStackVendorInfo } from "utils/vendor";

import StacksTableItemValue from "../../components/ItemValue";

type StacksTableVendorCellContentProps = {
  stack: Stack;
};

const StacksTableVendorCellContent = ({ stack }: StacksTableVendorCellContentProps) => {
  const { vendorConfig, effectiveTerraformVersion } = stack;

  // New opentofu stacks
  if (vendorConfig?.__typename == VENDOR_CONFIG_TYPENAME.OPEN_TOFU) {
    const label = vendorConfig.version || "";
    return <StacksTableItemValue icon={LogoOpentofu}>{label}</StacksTableItemValue>;
  }

  // TF Stacks/Stack view
  if (vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.TERRAFORM) {
    let label = effectiveTerraformVersion || vendorConfig.version || "";

    let icon = LogoTerraform;
    let tooltip: string = VENDOR_DICTIONARY.TERRAFORM;
    if (vendorConfig?.workflowTool === WorkflowTool.OpenTofu) {
      icon = LogoOpentofu;
      tooltip = VENDOR_DICTIONARY.OPEN_TOFU;
    }

    if (vendorConfig?.workflowTool === WorkflowTool.Custom) {
      icon = Gear;
      label = TERRAFORM_CUSTOM_VENDOR;
      tooltip = TERRAFORM_CUSTOM_VENDOR;
    }

    return (
      <StacksTableItemValue tooltip={tooltip} icon={icon}>
        {label}
      </StacksTableItemValue>
    );
  }

  if (vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.TERRAGRUNT) {
    const vendorInfo = getStackVendorInfo(vendorConfig);

    if (!vendorInfo)
      return <StacksTableItemValue tooltip={VENDOR_DICTIONARY.TERRAGRUNT} icon={LogoTerragrunt} />;

    return (
      <Box direction="column" gap="small">
        <StacksTableItemValue tooltip={VENDOR_DICTIONARY.TERRAGRUNT} icon={vendorInfo.vendor.icon}>
          {vendorInfo.vendor.text}
        </StacksTableItemValue>

        {vendorInfo.vendorTool && (
          <StacksTableItemValue icon={vendorInfo.vendorTool.icon}>
            {vendorInfo.vendorTool.text}
          </StacksTableItemValue>
        )}
      </Box>
    );
  }

  if (vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.PULUMI) {
    return <StacksTableItemValue tooltip={VENDOR_DICTIONARY.PULUMI} icon={LogoPulumi} />;
  }

  if (vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.KUBERNETES) {
    return <StacksTableItemValue tooltip={VENDOR_DICTIONARY.KUBERNETES} icon={LogoKubernetes} />;
  }

  if (vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.CLOUD_FORMATION) {
    return (
      <StacksTableItemValue tooltip={VENDOR_DICTIONARY.CLOUD_FORMATION} icon={LogoCloudformation} />
    );
  }

  if (vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.ANSIBLE) {
    return <StacksTableItemValue tooltip={VENDOR_DICTIONARY.ANSIBLE} icon={LogoAnsible} />;
  }

  return <TableCellEmpty />;
};

export default StacksTableVendorCellContent;
